<template>
  <div>
    <div>
      <div class="title">{{ arr }}</div>
      <ul v-if="typeof fensi == Array">
        <li v-for="item in fensi" :key="item.id">
          <div align="center">
            <img
              :src="item.avatar"
              v-if="item.avatar != '' && item.avatar != ' '"
            />
            <img src="../../assets/photoico.png" v-else />
          </div>
          <p>{{ item.user_nicename }}</p>
        </li>
      </ul>
      <div v-else>
        <Zanwu></Zanwu>
      </div>
    </div>
  </div>
</template>

<script>
import URL from "../../api/index";
import Zanwu from "../../components/common/zanwu";
export default {
  data() {
    return {
      arr: "我的粉丝",
      UserInfo: "",
      getSpaceinfo: "",
      fensi: "",
    };
  },
  components: {
    Zanwu,
  },
  mounted() {
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
    var that = this;
    var getSpacefans_data = {
      token: that.UserInfo.token,
      spaceid: that.getSpaceinfo.space_id,
    };
    // 获取粉丝列表
    this.$post(URL.getSpacefans, getSpacefans_data).then((res) => {
      // console.log(res.msg);
      that.fensi = res.msg;
    });
  },
  methods: {},
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.djimg {
  cursor: pointer;
}
.title {
  background-color: #fff;
  padding-left: 16px;
  margin-bottom: 15px;
  line-height: 50px;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  color: #4b4b4b;
}
ul {
  display: flex;
  flex-wrap: wrap;
  justify-self: space-around;
  li {
    border-radius: 5px;
    width: 31%;
    margin-right: 10px;
    background-color: #fff;
    float: left;
    padding: 20px 0 0;
    margin-left: 10px;
    margin-bottom: 20px;
    img {
      width: 75px;
      height: 75px;
      border-radius: 50%;
    }
    p {
      font-size: 14px;
      color: #2f2f2f;
      text-align: center;
      line-height: 70px;
    }
  }
}
</style>

